import { useState, useEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import "../../user-settings/components/UserSettingsProvider.js";
import { useColumnsSettings } from "../../user-settings/hooks.js";
import "moment-timezone";
import { maxPageSize } from "../../api/types.js";
import { getFilterString } from "../../api/utils.js";
import "immer";
import { Transaction } from "../../contract/pam.js";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { useAuthUser } from "../../auth/hooks.js";
import "oidc-client-ts";
import "../../auto-mapper/AutoMapperProvider.js";
import { useAutoMapper } from "../../auto-mapper/hooks.js";
import "@automapper/core";
import "date-fns";
import "../user-profile/constants.js";
import { useUserProfiles } from "../user-profile/hooks.js";
import "typesafe-actions";
import "normalizr";
import "redux-observable";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "../../redux-folder/entity/EntityProvider.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "../user-profile/epics.js";
import "../user-profile/actions.js";
import { gridUserProfileLocalizedHeaders } from "../user-profile/components/DataGrid.js";
import "../user-profile/components/Platform.js";
import "../../components/download/DownloadCsvButton.js";
import "../../components/download/DownloadTemplate.js";
import "../../components/filter/FilterGroupNew.js";
import "../../components/input/validation.js";
import "../../components/input/DatePicker.js";
import "../../components/input/DateRangePicker.js";
import "../../components/input/StyledInput.js";
import "../../components/input/FormInput.js";
import "../../components/input/StyledFormInputHoc.js";
import "../../components/input/DateSinglePicker.localize.js";
import "../../components/input/hooks.js";
import "@mui/material";
import "../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../components/filter/date-filter/DateFilter.js";
import "../../components/filter/TextFilterWithDropdown.js";
import "../../components/filter/MultiStepFilterDrawer.js";
import "../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../components/select/Select.js";
import "../../components/filter/TextFilter.js";
import "../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../components/filter/dateRangeFilter/localized.js";
import "../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../components/filter/MultiStepFilterApplyButton.js";
import "../../components/filter/MultiStepFilterInput.js";
import "../../components/filter/MultiStepFilterHoc.js";
import "../../components/chip/ChipRenderer.js";
import "../../components/select/selectStyle.js";
import "../../components/select/MultiSelectFooter.js";
import "../../components/select/MultiSelect.js";
import "../../components/select/MultiSelectItem.js";
import "../../components/select/SelectArrowIcon.js";
import "../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../components/select/SingleSelect.js";
import "../../components/select/MultiSelectWithExclude.js";
import "../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../components/filter/PhoneFilter.js";
import "../brand-license/constants.js";
import "../country/components/CountryFilter.js";
import "../brand-license/components/BrandProvider.js";
import "react-oidc-context";
import "../../components/alerts/NoAccessInfoMessage.js";
import "../brand-license/components/LicenseSelect.js";
import "../brand-license/components/BrandSelect.js";
import "../../components/circle-box/CircleBoxWithText.js";
import "../../components/label/EmptyLabel.js";
import "../../components/label/LabelHoc.js";
import "../../components/tooltip/Tooltip.js";
import "../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../style/hooks.js";
import "../../components/circle-box/CircleBox.js";
import "../user-profile/components/Filters.js";
import "../user-profile/components/P2PStatusCell.js";
import "../user-profile/components/UserDetailsWDBalance.js";
import "../user-profile/components/ReferralLinkButton.js";
import "../user-profile/components/PlayerIdAutocomplete.js";
import { useAsyncActionState } from "../../redux-folder/async-actions/hooks.js";
import "../../redux-folder/async-actions/actions.js";
import "../../intl/shared-resources/serverResponse.js";
import "react-router";
import "../../redux-folder/async-actions/reducers.js";
import "../../redux-folder/download/actions.js";
import "../../redux-folder/download/epics.js";
import { useDownload } from "../../redux-folder/download/hooks.js";
import { localizedBulkStepValidation } from "./components/BulkValidationStepContent.js";
import { localizedTransactionDataGridHeaders } from "./components/DataGrid.js";
import { transactionActions } from "./actions.js";
import { TransactionViewModelKeysTypeName, TransactionQueryFieldsTypeName, TransactionColumnSettingsKeysTypeName } from "./constants.js";
import { TransactionViewModel, ValidationCode, bulkTransactionsMaxTemplateLine } from "./types.js";
const localized = defineMessages({
  total: {
    id: "useTransactions_totalLabel",
    defaultMessage: "Total"
  }
});
function useTransactions({
  viewType,
  fields,
  displayName,
  cleanDelay = 0,
  realtimeMode,
  triggers,
  defaultFilters,
  hiddenFilters,
  defaultPaging,
  defaultSorting = "started",
  validateFilter,
  syncWithUrl = false,
  showTotal = false,
  transactionEntityType
}, userProfileProps) {
  const mapper = useAutoMapper();
  const { formatMessage } = useIntl();
  const {
    items: transactions,
    totalCount,
    searchFilter,
    viewEntity: { filter: filterString },
    handlePageChange,
    handlePageSizeChange,
    handleSortChange,
    handleFilterChange
  } = useViewInit({
    viewType,
    displayName,
    entity: {
      entity: transactionEntityType,
      fields: showTotal ? [...mapFields(fields), "total_amount"] : mapFields(fields)
    },
    realtime: realtimeMode ? { entity: transactionEntityType, mode: realtimeMode, triggers } : null,
    defaultSorting: getDefaultSorting(),
    hiddenFilters,
    defaultPaging,
    defaultFilters: showTotal ? [...defaultFilters, { key: "show_total_amount", value: true }] : defaultFilters,
    syncWithUrl,
    validateFilter,
    cleanDelay
  });
  const { items: users, rawItems: usersRawItems } = useUserProfiles({
    ...userProfileProps,
    validateFilter: userProfileProps?.validateFilter ?? (() => false),
    ids: transactions?.map((i) => i.uid)
  });
  const items = transactions?.filter((i) => !i.is_summary).map((i) => {
    const userIndex = users.findIndex((u) => u?.uid === i?.uid);
    const user = users?.[userIndex] ?? {};
    const userRaw = usersRawItems?.[userIndex] ?? { isValid: true, raw: "" };
    const { model, isModelValid, rawModelString } = mapper.tryMap(i, Transaction, TransactionViewModel);
    return {
      model: model ? { ...user, ...model, license_type: model?.license_type ?? user?.license_type } : null,
      isModelValid: isModelValid && userRaw.isValid,
      rawModelString: [rawModelString, userRaw.raw].join(",")
    };
  });
  const mappedSummaryItem = mapper.tryMap(
    transactions?.find((t) => t.is_summary),
    Transaction,
    TransactionViewModel
  );
  const summaryItem = {
    ...mappedSummaryItem.model,
    [fields[0]]: formatMessage(localized.total),
    is_summary: true
  };
  return {
    items: items?.map((i) => i.model),
    rawItems: items?.map((i) => ({ isValid: i.isModelValid, raw: i.rawModelString })),
    summary: summaryItem,
    summaryRaw: { isValid: mappedSummaryItem.isModelValid, raw: mappedSummaryItem.rawModelString },
    totalCount,
    searchFilter,
    filterString,
    handlePageChange,
    handlePageSizeChange,
    handleSortChange: handleVmSortChange,
    handleFilterChange
  };
  function getDefaultSorting() {
    const sorting = {
      started: [
        {
          field: "transaction_started_ts",
          sort: "desc"
        }
      ],
      updated: [
        {
          field: "transaction_updated_ts",
          sort: "desc"
        }
      ]
    };
    return sorting[defaultSorting];
  }
  function mapFields(fields2) {
    return mapper?.map(
      fields2,
      TransactionViewModelKeysTypeName,
      TransactionQueryFieldsTypeName
    );
  }
  function mapField(field) {
    return mapFields([field])[0];
  }
  function mapSorting(sorting) {
    return sorting?.map((s) => ({ ...s, field: mapField(s?.field) }));
  }
  function handleVmSortChange(newSorting) {
    handleSortChange(mapSorting(newSorting));
  }
}
function useDownloadTransaction({
  filterString,
  keys,
  userProfileKeys,
  filename,
  showTotal = false,
  mode,
  downloadServerStrategyId,
  total
}) {
  const { handleDownload: defaultHandleDownload, isProgress: defaultIsProgress } = useDownload({
    filename,
    filter: filterString,
    mode,
    total,
    strategySymbol: downloadServerStrategyId,
    keys,
    headersLocalization: localizedTransactionDataGridHeaders
  });
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const mapper = useAutoMapper();
  const { isProgress: customIsProgress } = useAsyncActionState(transactionActions.transactionDownloadCsv);
  const pageFilterKey = "page";
  const sizeFilterKey = "size";
  const showTotalKey = "show_total_amount";
  const filter = getFilterString(
    filterString,
    true,
    { key: pageFilterKey, value: "1" },
    { key: sizeFilterKey, value: `${maxPageSize}` },
    { key: showTotalKey, value: showTotal ? true : null }
  );
  const fields = mapper.map(
    keys,
    TransactionViewModelKeysTypeName,
    TransactionQueryFieldsTypeName
  );
  const transactionHeader = keys?.reduce(
    (previousValue, key) => {
      previousValue[key] = formatMessage(localizedTransactionDataGridHeaders[key]);
      return previousValue;
    },
    {}
  );
  const userProfileHeader = userProfileKeys?.reduce(
    (previousValue, key) => {
      previousValue[key] = formatMessage(gridUserProfileLocalizedHeaders[key]);
      return previousValue;
    },
    {}
  );
  const customHandleDownload = () => {
    if (mode === "client") {
      dispatch(
        transactionActions.transactionDownloadCsv.request({
          fields: showTotal ? [...fields, "total_amount"] : fields,
          worksheetKeys: keys,
          userWorksheetKeys: userProfileKeys,
          filter,
          filename,
          headers: { ...transactionHeader, ...userProfileHeader }
        })
      );
    }
  };
  return mode === "client" ? { isProgress: customIsProgress, handleDownload: customHandleDownload } : { isProgress: defaultIsProgress, handleDownload: defaultHandleDownload };
}
function useTransactionSettings({
  settingId,
  defaultColumns,
  pinnedColumns = []
}) {
  const { sub } = useAuthUser();
  const mapper = useAutoMapper();
  const { visible, onVisibleColumnsChange } = useColumnsSettings({
    userId: sub,
    settingId,
    defaultColumns: mapViewModelKeysToSettings(defaultColumns),
    pinnedColumns: mapViewModelKeysToSettings(pinnedColumns)
  });
  function mapViewModelKeysToSettings(keys) {
    return [
      ...new Set(
        keys?.map(
          (i) => mapper.map(
            i,
            TransactionViewModelKeysTypeName,
            TransactionColumnSettingsKeysTypeName
          )
        ) ?? []
      )
    ];
  }
  function mapSettingsToViewModelKeys(settings) {
    return [
      ...new Set(
        settings?.map(
          (i) => mapper.map(
            i,
            TransactionColumnSettingsKeysTypeName,
            TransactionViewModelKeysTypeName
          )
        ) ?? []
      )
    ];
  }
  function handleColumnSettingsChange(fields) {
    const columns = mapViewModelKeysToSettings(fields);
    onVisibleColumnsChange(columns);
  }
  return {
    visibleColumns: mapSettingsToViewModelKeys(visible).filter((f) => defaultColumns.includes(f)),
    onVisibleColumnsChange: handleColumnSettingsChange
  };
}
function getValidationErrorItems(invalidItems) {
  const { formatMessage } = useIntl();
  const [errorItems, setErrorItems] = useState([]);
  useEffect(() => {
    setErrorItems(getErrorItems());
  }, []);
  const getErrorItems = () => {
    return invalidItems.reduce((items, result) => {
      const model = result.item;
      return [...items, ...result.errors?.map(({ errorCode, data }) => getErrorItem(result.id, model.uid, errorCode, data)) ?? []];
    }, []);
  };
  const getErrorItem = (id, uid, errorCode, data) => {
    const errorMessageMapper = {
      [ValidationCode.AmountNotInteger]: localizedBulkStepValidation.amountNotInteger,
      [ValidationCode.AmountNotNumber]: localizedBulkStepValidation.amountNotNumber,
      [ValidationCode.AmountNotPositive]: localizedBulkStepValidation.amountNotPositive,
      [ValidationCode.AmountDecimalPartLengthIsNotValid]: localizedBulkStepValidation.amountDecimalPartLengthIsNotValid,
      [ValidationCode.LineIsTooLarge]: formatMessage(localizedBulkStepValidation.lineIsTooLarge, {
        maxTransactionLines: bulkTransactionsMaxTemplateLine
      }),
      [ValidationCode.ReasonInvalid]: localizedBulkStepValidation.reasonCodeIsNotValid,
      [ValidationCode.TypeInvalid]: localizedBulkStepValidation.typeIsNotValid,
      [ValidationCode.UidNotExists]: localizedBulkStepValidation.uidNotExists,
      [ValidationCode.BalanceIsNotEnough]: localizedBulkStepValidation.balanceIsNotEnough,
      [ValidationCode.AmountIsTooLarge]: formatMessage(localizedBulkStepValidation.amountIsTooLarge, { amount: data }),
      [ValidationCode.TotalAmountIsTooLarge]: localizedBulkStepValidation.totalIsTooLarge,
      [ValidationCode.DuplicatesNotAllowed]: localizedBulkStepValidation.duplicatesNotAllowed,
      [ValidationCode.DownlinePlayersOnlyAllowed]: localizedBulkStepValidation.downlinePlayersOnlyAllowed,
      [ValidationCode.UploadedDataIsInvalid]: localizedBulkStepValidation.uploadedDataIsInvalid,
      [ValidationCode.AgentNotInP2PChannel]: formatMessage(localizedBulkStepValidation.playerNotInP2PChannel, {
        uid: data
      }),
      [ValidationCode.PlayerNotInP2PChannel]: formatMessage(localizedBulkStepValidation.playerNotInP2PChannel, {
        uid: data
      })
    };
    return {
      id: `${id}_${errorCode}`,
      serverId: `${id}_${errorCode}`,
      rowIndex: id,
      uid,
      error: errorMessageMapper[errorCode]
    };
  };
  return errorItems;
}
function useLastTransaction({
  uid,
  viewType,
  types,
  transactionEntityType
}) {
  const { items } = useTransactions({
    viewType,
    fields: ["amount", "currency", "transaction_started_ts", "transaction_id"],
    defaultFilters: [
      { key: "uid", value: uid },
      { key: "transactionTypes", value: types }
    ],
    defaultPaging: {
      page: 1,
      pageSize: 1
    },
    defaultSorting: "started",
    validateFilter: () => true,
    transactionEntityType
  });
  return items?.length ? items[0] : null;
}
export {
  getValidationErrorItems,
  useDownloadTransaction,
  useLastTransaction,
  useTransactionSettings,
  useTransactions
};
//# sourceMappingURL=hooks.js.map
